// extracted by mini-css-extract-plugin
module.exports = {"page-tabbar":"page-tabbar-8395124633bbc240349839f36ce1120d"};